
import { Injectable, Injector } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NdmsResolverService } from '../interfaces/ndmsResolverService';


@Injectable()
export class NdmsRouteResolverGuard implements Resolve<any> {
  private _resolvePromises = {};
  
  static PreloadIndicator = true;

  constructor(private injector: Injector, private location: Location) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    let service: NdmsResolverService = this.injector.get(route.data.service);

    if (state.url.includes('rms')) {
      if (!this._resolvePromises[service.constructor.name]) {
        this._resolvePromises[service.constructor.name] = new Promise<any>(async (resolve, reject) => {
          service.resolve(route).then((data) => resolve(data)).catch((error) => reject(error));
        });
      }
      this._resolvePromises[service.constructor.name]
        .catch(() => this.location.back())
        .finally(() => {
          this._resolvePromises[service.constructor.name] = undefined;
          if (NdmsRouteResolverGuard.PreloadIndicator) {
            NdmsRouteResolverGuard.PreloadIndicator = (Object.keys(this._resolvePromises).filter(key => this._resolvePromises[key]).length > 0);
          }
        });

      return this._resolvePromises[service.constructor.name];
    } else {
      NdmsRouteResolverGuard.PreloadIndicator = false;
      return service.resolve(route);
    }
  }

}
